// Vendor
import 'bootstrap';

// Theme
import './autosize';
import './bootstrap';
import './checklist';
import './choices';
import './dropzone';
import './flatpickr';
import './highlight';
import './inputmask';
import './kanban';
import './list';
import './map';
import './navbar-collapse';
import './navbar-dropdown';
import './popover';
import './tooltip';
import './wizard';
// User
import './user';
